<template>
    <div id="new-paint" v-show="is_open">
      <loading
        :active="false"
        :can-cancel="false"
        :is-full-page="false"
      />
      <div
        style="text-align:left; margin-top: 15px;"
      >
      <b-form-group>
      <div v-show="parent_id==-1">
      New hierarchy name:
      <div style="display:flex; margin-top:16px;" class="mb-10">
        <div style="width:70%">
          <b-form-input
          id=""
          ref=""
          v-model="new_node.hierarchy_name"
          placeholder="Hierarchy name"
        />
        </div>
      </div>
    </div >
        Node name: 
        <div style="display:flex; margin-top:16px" class="mb-10">
            <div style="width:70%">
            <b-form-input
            id=""
            ref=""
            v-model="new_node.node_name"
            placeholder="Node name"
            />
            </div>
        </div>
        <div style="margin-top:15px">
          <b-form-checkbox
                v-model="new_node.perform_normalization"
                class="custom-control-secondary"
        > 
            Perform Normalization 
        </b-form-checkbox>
        <b-form-checkbox
                v-model="new_node.perform_sampling"
                class="custom-control-secondary"
            
        > 
            Perform Data Sampling 
        </b-form-checkbox>
        </div>      
        <div style="margin-top:10px">
          Cells:
          <b-form-spinbutton-input
            :state="false"
            style="margin-top:5px"
            id="80"
            v-model="totalCells"
            :disabled="false"
            :readonly="false"
            :min="1"
            :max="1000000"
            :width="140"
   
          />

        </div>
      
   
      
      
        <b-button
       
          variant="primary"
          size="sm"
          class="mt-1"
          right:0
          @click="addNewNode"
        >
          ADD  NODE
        </b-button>
      </b-form-group>
        
      </div>
    </div>
  </template>
  <script>
  import Vue from 'vue'
  import { BButton,  BFormInput, BFormGroup, BRow, BCol, BFormCheckbox, BFormSpinbutton } from 'bootstrap-vue'
  import InputColorPicker from 'vue-native-color-picker'
  import 'vue-range-component/dist/vue-range-slider.css'
  import VueRangeSlider from 'vue-range-component'
  import store from '@/store/index'
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import BlockInput from '../components/blockInputs.vue'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { ToggleButton } from 'vue-js-toggle-button'
  import BFormSpinbuttonInput from '@core/components/b-form-spinbutton-input/BFormSpinbuttonInput.vue'
  import Swal from 'sweetalert2'
  
  const { url, port, auth } = store.state.appConfig.api
  const headers = {
    authentication: auth,
    'Content-Type': 'application/json',
  }
  
  export default {
    components: {
      BFormInput,
      BFormGroup,
      BRow,
      BFormSpinbuttonInput,
      BCol,
      InputColorPicker,
      VueRangeSlider,
      BButton,
      Loading,
      ToggleButton,
      BFormCheckbox,
      BlockInput,
      BFormSpinbutton
    },
    props: {
     
      project_id: {
        required: true,
        type: Number,
        default: 0,
      },
      parent_id: {
        required: false,
        type: Number,
        default: 0,
      },
   
      
     
    },
    data() {
      return {
        new_node: {
            hierarchy_name: '',
            node_name: '',
            perform_normalization: true,
            perform_sampling: true,
            cell_number: 25000,

        },
        modelOptions: [],
        totalCells: 25000,
        isLoadingInfo: true,
        is_open: true,
        change_percent: false,
        newcolor: this.color,
        histogram_x: [],
        histogram_y: [],
        histogram: {},
        update: 0,
        img: '',
        isLoading: false,
        newbrightness: this.brightness,
        newcontrast: this.contrast,
        newsaturation: this.saturation,
        bgStyle: {
          backgroundColor: '#fff',
          boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
        },
        tooltipStyle: {
          backgroundColor: '#666',
          borderColor: '#666',
        },
        processStyle: {
          backgroundColor: '#999',
        },
        objectNameEdit:'',
        colorPickerEdit:'',
      
      }
    },
    created() {
 
  
    },
  
  
    
    methods: {
      addNewNode(){
        const { new_node, totalCells, parent_id, project_id } = this
   
        if(new_node.node_name != ''){
      
            Swal.fire({
              title: 'Run all steps',
              text: "Do you want to compute all the steps directly up to digital reconstruction?",
              showCancelButton: true,
              confirmButtonText: 'Run all steps',
              cancelButtonText: 'Go step by step',
              customClass: {
                confirmButton: 'btn btn-primary mt-4',
                cancelButton: 'btn btn-primary ml-1 mt-4',
              },
              buttonsStyling: false,
            }).then(result => {
              if (result.value) {
                this.createNode(new_node, 1)
              }
              else{
                this.createNode(new_node, 0)
              }
            })
          
          
        }
      },
      calculate_cells(node_id){
          console.log("Calculate cells")
          const {   project_id } = this
   
          axios.post(`${url}:${port}/downstream-cells/${project_id.id}/${node_id}`, { }, { headers }).then(result => {
          
            console.log(result)
          })
        },
      createNode(new_node, compute = 0){

        const {  parent_id,totalCells,  project_id } = this
        var names = 'test'
        if(new_node.node_name !== ''){
          names = new_node.node_name
        }
        var descp = 'node'
        if(parent_id == 0){
          descp = new_node.hierarchy_name ?? ''
        }
        var data2send = {
          project_id: project_id.id,
          name: names,
          description: descp,
          parent_id: parent_id,
          hier_name: names,
          totalCells:totalCells,
          do_all_steps: compute
        }
        axios.put(`${url}:${port}/downstream-newnode`, data2send, { headers }).then(async result => {
          console.log("result", result)
            this.calculate_cells(result.data.id)
          
       
          location.reload()
        })

        this.new_node = new_node
      }
    
      
     
      
    
    },
  }
  </script>
  <style>
  .icp__input {
      height: 20px!important;
      width: 20px!important;
      margin-right:10px;
  }
  .swal2-actions{
   margin: 0 10px;
    /* display: none !important;  */
  }
  .vue-range-slider.slider-component {
    margin-left:0px!important;
  }
  .sat_slider{
      margin-top: -30px!important;
      margin-bottom: 20px!important;
  }
  #new-paint .swal2-confirm swal2-styled{
    /* display: none; */
    
  }
  /* .vue-js-switch .v-switch-core[data-v-25adc6c0] {
      background-color: dodgerblue !important;
  } */
  
  </style>
  <style scoped>
  
  h4{
      display: flex;
      align-items: flex-start;
  }
  #content{
      display: flex;
      width: 100%;
      height: 400px;
      justify-content: space-between;
  }
  #picture{
      width: 55%;
      display: flex;
      align-items: center;
  }
  #picture img{
      max-width: 90%;
      max-height: 365px
  }
  #histograms{
      width: 40%;
  }
  .mb-10{
    margin-bottom: 10px;
  }

.validInput .input-group-text{
    background-color: #29c770;
    color: #fff;
}
.b-form-spinbutton{
  max-width: 100px;
}
.is-valid.b-form-spinbutton{
      max-width: 135px!important;
}
.spinBtRow{
  flex-direction: column;
}
.spinBtRow div{
    max-width: 100%!important;
}
.spinBtRow div.input-group{
  max-width: 110px!important;
}
</style>
    